const bannerList = [
  {
    image: "/assets/images/Album.jpg",
    banner: "Albums",
  },
  {
    image: "/assets/images/Concert.jpg",
    banner: "Wearables",
  },
  {
    image: "/assets/images/Album.jpg",
    banner: "Accessories",
  },
];

const cardList = [
  {
    image: "/assets/images/album2.jpg",
    title: "New Arrivals",
    msg: "Check out the latest wearables collections.",
    category: "Wearables",
  },
  {
    image: "/assets/images/taylor-swift-album.jpg",
    title: "All Categories",
    msg: "Check out the latest collection and grab the limited edition.",
    category: "",
  },
];

export { bannerList, cardList };
